import axios from "axios"
import axiosAuthRequired from "./axiosAuthRequired"
import * as contentful from "contentful"

const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (clientCredentials) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

const GAMES = {
  "leagueoflegends": {
    name: "League of Legends",
  },
  "fortnite": {
    name: "Fortnite",
  },
  "csgo": {
    name: "Counter Strike: GO",
  },
  "teamfight-tactics": {
    name: "Teamfight Tactics",
  },
  "hearthstone": {
    name: "Hearthstone",
  },
  "magic-the-gathering": {
    name: "Magic: The Gathering Arena",
  },
  "super-smash-bros-ultimate": {
    name: "Super Smash Bros. Ultimate",
  },
  "overwatch": {
    name: "Overwatch",
  },
  "world-of-warcraft": {
    name: "World of Warcraft",
  },
}

export const USER_VIEWS = [
  {
    id: 1,
    articleId: 1,
  },
]

export const getGames = () => {
  return GAMES
}

export const getArticle = id => {
  return new Promise((resolve, reject) => {
    getContentfulClient()
      .getEntry(id)
      .then(entry => {
        resolve(entry)
      })
      .catch(error => {})
  })
}

export const getArticleBySlug = urlSlug => {
  return new Promise((resolve, reject) => {
    getContentfulClient()
      .getEntries({
        "content_type": "article",
        "fields.urlSlug": urlSlug,
      })
      .then(entries => {
        let entry = entries.items.length > 0 ? entries.items[0] : null
        resolve(entry)
      })
      .catch(error => {})
  })
}

export const getVotesForArticle = entryId => {
  let url = "/api/v2/community/voteable/contentful_entry/" + entryId
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const castArticleVote = (entryId, selectedOption) => {
  let url = "/api/v2/community/voteable/contentful_entry/" + entryId
  let body = new FormData()
  body.append("voteable_type", "binary")
  body.append("choice", selectedOption)

  return axiosAuthRequired({
    method: "post",
    url: url,
    data: body,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

const formatPollData = pollData => ({
  id: pollData.id,
  entryId: pollData.entry_id,
  header: pollData.header,
  summary: pollData.question,
  articleId: pollData.article_entry_id,
  options: pollData.options.map(option => ({
    label: option,
    votes: 0,
  })),
})

export const getContentfulPolls = (games, cursor, count) => {
  let queryStringComponents = {}

  if (games) {
    queryStringComponents.games = games.join(",")
  }

  cursor = cursor || null
  if (cursor) {
    queryStringComponents.cursor = cursor
  }

  count = count || null
  if (count) {
    queryStringComponents.count = count
  }

  let queryStringPieces = []
  for (let key in queryStringComponents) {
    queryStringPieces.push([key, queryStringComponents[key]].join("="))
  }
  let queryString = queryStringPieces.join("&")

  return axios({
    method: "get",
    url:
      "/api/v2/services/contentful/content-model-integrations/polls?" +
      queryString,
  })
    .then(response => {
      let pollsData = response.data
      return {
        polls: pollsData.polls.map(poll => formatPollData(poll)),
        nextCursor: pollsData.next_cursor,
      }
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getContentfulPoll = entryId => {
  return axios({
    method: "get",
    url:
      "/api/v2/services/contentful/content-model-integrations/polls/" + entryId,
  })
    .then(response => {
      return formatPollData(response.data)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getVotesForPoll = id => {
  let url = "/api/v2/community/voteable/contentful_poll/" + id
  return axiosAuthRequired({
    method: "get",
    url: url,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const castVote = (pollId, selectedOption) => {
  let url = "/api/v2/community/voteable/contentful_poll/" + pollId
  let body = new FormData()
  body.append("voteable_type", "poll")
  body.append("choice", selectedOption)

  return axiosAuthRequired({
    method: "post",
    url: url,
    data: body,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const getContentfulClient = () => {
  return contentful.createClient({
    space: "hdj76fsccgd5",
    accessToken: "ONZkWQQpluvOJf5XmWsvd7AoW_BFcZZyq2GgnQotzxo",
  })
}

export const queryArticles = settings => {
  return getContentfulClient().getEntries(settings)
}

export const getViewByArticle = articleId => {
  return new Promise((resolve, reject) => {
    resolve(USER_VIEWS.find(view => view.articleId === articleId))
  })
}



// WEBPACK FOOTER //
// ./src/api/trending.js